import { render, staticRenderFns } from "./EditZap.vue?vue&type=template&id=0b8a1a50&scoped=true&"
import script from "./EditZap.vue?vue&type=script&lang=js&"
export * from "./EditZap.vue?vue&type=script&lang=js&"
import style0 from "./EditZap.vue?vue&type=style&index=0&id=0b8a1a50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8a1a50",
  null
  
)

export default component.exports